module.exports = __webpack_public_path__ + "static/media/user-dark.36be2043.svg";